<template>
	<div class="pr-5 pl-5 pt-3 page-fill">
		<div class="row w-full mb-3 justify-between flex" style="align-items: center">
			<h1>Projects</h1>
			<div class="cardbody">
				<div class="flex flex-row-reverse items-center">
					<div class="flex flex-row-reverse items-center gap-3">
						<button class="flex" @click="filterOpen" :class="tableRow.length == 0 ? 'filterButtondisabled pointer-events-none' : 'filterButton'">
							<img  v-if="tableRow.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
							<img v-else src="@/assets/filter.svg" class="filterIcon" />
							Filters
						</button>
					</div>
				</div>
			</div>
		</div>
        <div class="mt-3">
            <p class="headerText">
				Define, organize, and manage security controls for your organization's projects to ensure consistent implementation, effective monitoring, and compliance with internal policies and external compliance frameworks. 
            </p>
        </div>
		<div class="mt-5 table-section">
			<tableData class="flex-1 min-h-0" :tableRowData="tableRow" :headersData="headers" :tableRouteArr="optionsValue" :loadData="dataLoading"></tableData>
			<div v-if="toolTipActive">
				<tool-tip :tipText="toolTipText"></tool-tip>
			</div>
		</div>
		<popup v-if="showActivityPopup" :popUp="showActivityPopup">
				<template v-slot:header>
					<div class="flex items-center justify-between py-4 px-2 rounded">
						<h1 class="pl-2">Project</h1>
						<button class="float-right text-3xl" @click="onCancelbtn()">
							<img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
						</button>
					</div>
				</template>
				<fieldset>
					<div>
						
						<div>
							<div class="statuscontainer popupbodycontainer">
								<div class="formcontainer flex flex-col">
									<div class="row flex flex-row w-full">
										<div class="row flex flex-row w-full">
											<div class="w-6/12">
												<label class="text-xs font-extrabold">System</label>
												<div class="mb-3 mt-2 text-sm">{{ activityObj?.systemName || 'N/A'}}</div>
											</div>
											<div class="w-3/6 leftspacing">
												<label class="text-xs font-extrabold">Category</label>
												<div class="mb-3 mt-2 text-sm">{{ activityObj?.sytemCategory || 'N/A'}}</div>
											</div>
										</div>
									</div>
									<!-- criticality -->
									<div class="row flex flex-row w-full">
										<div class="w-6/12">
											<label class="text-xs font-extrabold">Vendor</label>
											<div class="mb-3 mt-2 text-sm">{{ activityObj?.vendor || 'N/A'}}</div>
										</div>
										<div class="w-3/6 leftspacing">
											<label class="text-xs font-extrabold">Vendor Category</label>
											<div class="mb-3 mt-2 text-sm">{{ activityObj?.vendorCategory || 'N/A' }}</div>
										</div>
									</div>
									<div class="row flex flex-row w-full">
										<div class="w-3/6">
											<label class="text-xs font-extrabold">Model</label>
											<div class="mb-3 mt-2 text-sm">{{ activityObj?.model || 'N/A' }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</fieldset>
			</popup>
		
	</div>
</template>
<style scoped>
</style>
<script lang="ts">
import { emitter, toast } from '@/main';
import { defineComponent } from 'vue';
import useVuelidate from '@vuelidate/core';
import tableData from '@/components/tableData.vue';
import popup from '@/components/popup.vue';
import toolTip from '@/components/toolTip.vue';
// import loader from '@/components/loader.vue';
export default defineComponent({
	data(): any {
		return {
			headers:['Project','Type','Customer','projectOwner','entityDisplayName','Time Period','severity','controlscount','status'],
			v$: useVuelidate(),
			departmentsList: [],
			tableRow: [],
			activityObj: {},
			orgUsersList: [],
			optionsUserArray: [],
			controlsCountList: [],
			columnObject: false,
			showActivityPopup: false,
			showLoader: false,
			showFilters: false,
			criticalityArray: [
				{ label: 'Very Low', id: 1 },
				{ label: 'Low', id: 2 },
				{ label: 'Moderate', id: 3 },
				{ label: 'High', id: 4 },
				{ label: 'Critical', id: 5 }
			],
            projectTypeOptions : [
				{
					label:'Customer',
					value:10703

				},
				{
					label:'Internal',
					value:10704

				}
			],priorityData: [
				{
                    id: 1,
                    value: 'P1'
                },
				{
                    id: 2,
                    value: 'P2'
                },
				{
                    id: 3,
                    value: 'P3'
                },
				{
                    id: 4,
                    value: 'P4'
                },
                {
                    id: 5,
                    value: 'P5'
                },
            ],severitydata:[
                   
                        {
                            id:1,
                            value:'Very Low'
                        },
                        {
                            id:2,
                            value:'Low'
                        },
                        {
                            id:3,
                            value:'Moderate'
                        },
                        {
                            id:4,
                            value:'High'
                        },
                        {
                            id:5,
                            value:'Very High'
                        }
                       
                    ],
			toolTipActive : false,
			toolTipText : '',
			optionsValue: [
				{
					id: 1,
					value: 'Select',
					route: '/departmentControls',
					presentRoute: '/org/controls/controlMapping'
				}
			], 
			dataLoading:true,
      systems:[],
      vendorList:[],
	  systemVendors:[],
	  matchedVendor:[],
      entitesDataArray:[]
		};
	},
	components: {
		tableData,
		// loader,
		popup,
		toolTip
	},
	mounted() {
		// this.dataLoading = false;
		for (const row of this.tableRow) {
			for (const value of Object.values(row)) {
				if (value == '') {
					this.columnObject = true;
				} else {
					this.columnObject = false;
				}
			}
		}
		// emitter.off('controlMappingData')
        // emitter.on("controlMappingData", (isData: any) => {
		// 	console.log('isData',isData);
			
		// 	let comingId = isData.entityData._id;
		// 	this.showEditPopUp(isData.entityData);
        // });
        emitter.off('controlMappingData')
		this.bindRowClickListeners();
		emitter.off('activiteToolTip');
		emitter.on('activiteToolTip', (data: any) => {
			this.toolTipActive = true;
			this.toolTipText = data.tipText
		});
		emitter.off('deActiviteToolTip');
		emitter.on('deActiviteToolTip', (data: any) => {
			this.toolTipActive = false;
			this.toolTipText = ''
		});
		emitter.off('detailsModalClosed');
		emitter.on('detailsModalClosed', this.refreshAfterDetailsModal);
	},
	beforeUnmount() {
		emitter.off('detailsModalClosed', this.refreshAfterDetailsModal);
		if (this.onControlMappingData) {
			emitter.off('controlMappingData', this.onControlMappingData);
		}
	},
	methods: {
		filterOpen() {
			if(this.columnObject == false){
				this.showFilters = !this.showFilters;
				emitter.emit('visible', this.showFilters);
			}
		},
		async refreshAfterDetailsModal() {
			await this.getAllProjects();
			this.bindRowClickListeners();
		},
		bindRowClickListeners() {
			if (this.onControlMappingData) {
				emitter.off('controlMappingData', this.onControlMappingData);
			}
			this.onControlMappingData = (isData: any) => {
				this.showEditPopUp(isData.entityData);
			};
			emitter.on('controlMappingData', this.onControlMappingData);
		},
		onCancelbtn() {
			this.v$.$reset();
			this.showActivityPopup = false;
			this.activityObj = {}
		},
		showEditPopUp(obj: any) {
            emitter.emit('openDetailsModal', {
                view: 'projectControls',
                title: obj.Project || obj.projectName || 'Project',
                params: { id: obj._id },
            });
		},
    	async getAllVendors(){
        // this.vendorCategoryDisplayList = [];
        this.vendorList = [];
        // this.vendorLabelList = []
        try{
			this.showLoader=true;
            await this.$http
                .get(`${process.env.VUE_APP_ORG_API}/api/org/getall/20003`)
                .then((response: any) => {
                    
                    let arr:any = response.data;
                    this.vendorList = arr


					if(this.vendorList.length > 0) {
						for(let i=0;i<this.vendorList.length;i++) {							
							this.systemVendors.push({_id:this.vendorList[i]._id,name:this.vendorList[i].displayName,vendorCategory:this.vendorList[i].vendorCategory})							
						}
					}
                    // this.vendorList = [];

                    // arr.map((item:any)=>{
                    //     this.vendorCategoryDisplayList.push(item.vendorCategory);
                    //     let a = {value:item._id,label:item.name};
                    //     this.vendorLabelList.push(a)
                    // })
                })

        } catch(error: any) {
            toast.error('Error', {
              timeout: 1000,
              closeOnClick: true,
              closeButton: 'button',
              icon: true
            });
        };
		this.showLoader=false;
    },
    async getAllActiveUsers() {
        await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/active/getall`).then((res: any) => {
            this.users = res.data;
        });
        for (var i = 0; i < this.users.length; i++) {
            this.optionsUserArray.push({ label: this.users[i].name, value: this.users[i]._id });
        }
        
    },
    async getAllEntities() {
			this.entitesDataArray = [];
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
					res.data.map((obj: any) => {
                        let a = { value: obj._id, label: obj.entityDisplayName };
						this.entitesDataArray.push(a);
					});
			});
		},
    	async getAllProjects(){
			this.projectDataArray = [],
			this.tableRow = [];
			this.dataLoading = true;
			await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/projects/mappedcontrols/count`).then((res: any) => {
				this.originalProjectData = res.data;
				res.data.map((originalProjectData:any)=>{

					let locationoptions=this.entitesDataArray.find((obj:any)=>{
						
						// console.log(' obj.value', obj.value)
						// console.log('originalProjectData.value',originalProjectData.owner)
						return obj.value==originalProjectData.entity})
						// console.log('locationoptions',locationoptions)
					let typeoptions=this.projectTypeOptions.find((data:any)=>{return data.value==originalProjectData.projectType})
						// console.log('typeoptions',typeoptions,this.optionsUserArray)
					let Priority=this.priorityData.find((data:any)=>{
						// console.log('data.id',data.id)
						// console.log('originalProjectData',originalProjectData)
						return data.id==originalProjectData.priority})
						// console.log('Priorityq121212',Priority.value)
						// console.log('originalProjectData.Prio/rity',originalProjectData.Priority,this.severitydata)
					let severityData=this.severitydata.find((data:any)=>{
						// console.log('data',data.id)
						// console.log('originalProjectData',originalProjectData.severity)
						return data.id==originalProjectData.severity})
					let ownerInfo = this.optionsUserArray.find((user:any)=>{return user.value==originalProjectData.owner});      
					// console.log('severityData',severityData) 	
					let tableData = { 
                        '_id':originalProjectData._id,
                        'Type':typeoptions != undefined ? typeoptions.value : 'N/A',
                        'Project' : originalProjectData.projectName!=undefined?originalProjectData.projectName:'N/A',
                        'Customer' : originalProjectData.customerName != undefined && originalProjectData.customerName!=''? originalProjectData.customerName : 'N/A',
                        'projectOwner' : ownerInfo!=undefined?ownerInfo.label:'N/A',
                        'entityDisplayName' : locationoptions!=undefined?locationoptions.label:'N/A',
                        'Time Period':originalProjectData.startDate!= undefined && originalProjectData.endDate!=undefined? `${originalProjectData.startDate} to ${originalProjectData.endDate}` : 'N/A',
                        'Priority' :Priority.value!=undefined?Priority.value:'N/A',
                        'severity' : severityData.id!=undefined?severityData.id:'N/A',
                        'status' : originalProjectData.status==true ? 1:2 ,
						'controlscount':originalProjectData.controlCount?originalProjectData.controlCount:0	
								
					}
					this.tableRow.push(tableData)                    
					this.dataLoading = false;
					this.projectName=[]
					this.originalProjectData.forEach((name: any)=>{
                    if(name.projectName != null){
                       
                       this.projectName.push(name.projectName)
                    }
					})
				})
			})

		},
	// async fetchSystemsList() {
	// 		try {
	// 			this.showLoader = true;
	// 			await this.$http.get(`${process.env.VUE_APP_CONTROLS_API_URL}/api/org/systems/count/mappedcontrols`).then((res: any) => {
	// 				this.systems = res.data;
	// 				this.systems.map((data:any)=>{
    //             // headers:['systemName','category','model','vendorCategory','vendor','no.of controls'],
    //             let vendor:any = this.vendorList.find((obj:any)=>{ return obj._id == data.vendor})
    //             let lengthofMappedControls:any
    //             let category:any
    //             let model:any

    //             if(Object.keys(data).includes('mappedControls')){
    //                 lengthofMappedControls = data.mappedControls.length
    //             } else {
    //                 lengthofMappedControls = 0
    //             }

    //             if(Object.keys(data).includes('hostingType')){
    //               model = data.hostingType
    //             } else {
    //               model = "N/A"
    //             }

	// 			this.matchedVendor.push(data.hostingProvider);				
	// 			if(this.systemVendors.length>0) {
	// 				for(let i=0;i<this.systemVendors.length;i++) {
	// 						if(data.vendor == this.systemVendors[i]._id) {
	// 						data.hostingProvider = this.systemVendors[i].name;
	// 						data.vendorCategory = this.systemVendors[i].vendorCategory;
	// 					}
	// 				}
	// 			}

    //             let obj:any = {
    //                 _id:data._id,
    //                 systemName: data.systemName != undefined && data.systemName != '' ? data.systemName : 'N/A',

    //                 sytemCategory: data.systemCategory != undefined && data.systemCategory != '' ? data.systemCategory : 'N/A',

    //                 model:data.hostingType != undefined && data.hostingType != '' ? model : 'N/A',

    //                 vendorCategory: data.vendorCategory != '' && data.vendorCategory != undefined ? data.vendorCategory : 'N/A',

    //                 vendor:data.hostingProvider != undefined && data.hostingProvider != '' ? data.hostingProvider : 'N/A',

    //                 "no.of controls":data.controlCount?data.controlCount:0,
    //             }
    //             this.tableRow.push(obj)
	// 			this.dataLoading=false;
    //         })
	// 			});
	// 		} catch (e) {
	// 			toast.error('error', {
	// 				timeout: 1000,
	// 				closeOnClick: true,
	// 				closeButton: 'button',
	// 				icon: true
	// 			});
	// 		}
	// 		this.showLoader = false;
	// 	},
	},
	async created() {
		this.dataLoading = true;
        // await this.getAllVendors();
        await this.getAllActiveUsers();
        await this.getAllEntities();
        await this.getAllProjects();
		this.dataLoading = false;
		// await this.fetchSystemsList();
        // await this.getAllSystems();
	}
});
</script>

